import React, { useState } from 'react';
import Foto1 from '../../../../assets/images/mesh.gif';
import Foto2 from '../../../../assets/images/mesh.png';
import Card from 'react-bootstrap/Card';

import 'bootstrap/dist/css/bootstrap.min.css';

function Mesh() {
  return (
    <>
      <div className='container-fluid'>
        <div className='row'>
          <div className='col-sm-12 col-md-6'>
            <h1>Tecnologias - Redes Mesh</h1>
            <img src={Foto2} alt='problema' className='mb-2' />
            <Card className="text-center">
              <Card.Header><div className="opcoes">Melhorar a cobertura e reduzir a interferência entre diferentes redes</div></Card.Header>
              <Card.Body>
                {/* <Card.Title>Coleta de Informações e Análise do Ambiente</Card.Title> */}
                <Card.Text>
                  <div className='opcoes'>
                    <div>
                    
                      <strong>1. Eliminação de zonas mortas:  </strong>
                      As redes mesh oferecem cobertura abrangente, eliminando zonas sem sinal.
                    </div>
                    <br />
                    <div>
                      <strong>2. Conexão contínua: </strong>
                      Proporcionam uma conexão contínua e ininterrupta ao mover-se entre os pontos de acesso.
                      <strong>Todos os roteadores compartilham de um único SSID</strong>
                    </div>
                    <br />
                    <div>
                      <strong>3. Conexão mista: </strong>
                      As Redes Mesh podem ser utilizadas com cabo de rede ou não, isso proporciona mais flexibilidade.<br />
                      <strong> Dica: </strong>Interligar os roteadores através de cabo de rede continua sendo a melhor opção.
                    </div>

                  </div>
                </Card.Text>
                {/* <Button variant="primary">Go somewhere</Button> */}
              </Card.Body>
              <Card.Footer className="text-muted"><div className="opcoes">
              <strong>Observação:</strong> Recomenda-se que os roteadores usados em uma rede mesh sejam da mesma marca e modelo. 
              O fato de usarem a mesma tecnologia não garante compatibilidade.</div>
              </Card.Footer>
            </Card>

          </div>
          <div className='col-sm-12 col-md-6'>
            <div className=''>
              <img className="d-block w-100" src={Foto1} alt="Current slide" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Mesh;
